import { useContext } from 'react';
import { FoldersContext } from './Folders.context';

export const useFoldersContext = () => {
  const context = useContext(FoldersContext);
  if (!context) {
    throw new Error('useFoldersContext must be used within a FoldersProvider');
  }
  return context;
};
